<template>
  <d2-container>
    <template slot="header">
      <div class="app-container calendar-list-container">
        <div class="filter-container">
          <el-input size="small" @keyup.enter.native="handleFilter" style="width: 200px;margin-right: 10px;"
            class="filter-item" placeholder="姓名或账户" v-model="listQuery.name"> </el-input>
          <el-button size="small" class="filter-item" type="primary" icon="search" @click="handleFilter">搜索</el-button>
          <el-button size="small" class="filter-item" v-permission:function="['fileTemplateManager_btn_add']"
            style="margin-left: 10px;" @click="handleCreate" type="primary" icon="edit">添加</el-button>
            <el-button size="small" class="filter-item" type="primary" icon="search" @click="dialogFormVisible = true;dialogStatus = 'create'">上传</el-button>
        </div>
      </div>
    </template>

    <el-table :key='tableKey' :data="list" v-loading.body="listLoading" size="small" stripe highlight-current-row
      style="width: 100%">

      <el-table-column align="center" label="id" width="65">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column width="700px" align="center" label="文书名称">
        <template slot-scope="scope">
          <span>{{ scope.row.fileName }}</span>
        </template>
      </el-table-column>

      <el-table-column fixed="right" align="center" label="操作" width="350"> <template slot-scope="scope">
          <el-button v-permission:function="['fileTemplateManager_btn_download']" size="small" type="success"
            @click="download(scope.row.id)">下载
          </el-button>
          <el-button v-permission:function="['fileTemplateManager_btn_edit']" size="small" type="success"
            @click="handleUpdate(scope.row)">变更模板
          </el-button>
          <el-button v-permission:function="['fileTemplateManager_btn_del']" size="small" type="danger"
            @click="handleDelete(scope.row)">删除
          </el-button>
        </template> </el-table-column>
    </el-table>
    <template slot="footer">
      <div v-show="!listLoading" class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
          layout="total, sizes, prev, pager, next, jumper" :total="total"> </el-pagination>
      </div>
    </template>
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="文书名称" prop="fileName">
          <el-input v-model="form.fileName" placeholder="请输入文书名称"></el-input>
        </el-form-item>
        <el-form-item label="文书上传" prop="file">
          <el-upload class="upload-demo" ref="upload" :action="uploadAction()" :http-request="HttpUploadFile" :limit="1"
            :on-change="fileChange" :file-list="fileList" :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          </el-upload>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')" size="small">取 消</el-button>
        <el-button v-if="dialogStatus == 'create'" size="small" type="primary" @click="submitUpload">确 定</el-button>
        <el-button v-else type="primary" size="small" @click="update()">更 新</el-button>
      </div>
    </el-dialog>

  </d2-container>
</template>

<script>
import {
  page,
  addObj,
  getObj,
  delObj,
  putObj
} from '@/api//fileTemplate/index';
import _collectionToJson from 'core-js/modules/_collection-to-json';
import { mapGetters } from 'vuex';
import util from "@/libs/util";
import axios from 'axios';
import singleUpload from "@/pages/components/upload"
import {
  directUpload
} from "@/api/czManager/czCaseInfo/index";
export default {
  name: 'fileTemplate',
  components: {
    singleUpload
  },
  data() {
    return {
      form: {
        id: undefined,
        fileName: undefined
      },
      rules: {
        fileName: [
          {
            required: true,
            message: '请输入文书名称',
            trigger: 'blur'
          }
        ], fileId: [
          {
            required: true,
            message: '请输入OSS的id',
            trigger: 'blur'
          }
        ]
      },
      fileList: [],
      fileParams: null,
      fileData: '',
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        name: undefined
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      tableKey: 0,
      admin: {
        userImg: ''
      },
      testVisible:false
    }
  },
  created() {
    this.getList();
  },
  computed: {
    ...mapGetters([
      'elements'
    ])
  },
  methods: {
    getList() {

      this.listLoading = true;
      page(this.listQuery).then(response => {
        this.list = response.rows;
        this.total = response.total;
        this.listLoading = false;
      })
    },
    handleFilter() {
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleCreate() {
      this.resetTemp();
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
    },
    handleUpdate(row) {
      getObj(row.id)
        .then(response => {
          this.form = response;
          this.dialogFormVisible = true;
          this.dialogStatus = 'update';
        });
      this.fileData = new FormData();
    },
    handleDelete(row) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delObj(row.id)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '删除成功',
                type: 'success',
                duration: 2000
              });
              const index = this.list.indexOf(row);
              this.list.splice(index, 1);
            });
        });
    },
    create(formName) {
      const set = this.$refs;
      set[formName].validate(valid => {
        if (valid) {
          addObj(this.form)
            .then(() => {
              this.dialogFormVisible = false;
              this.getList();
              this.$notify({
                title: '成功',
                message: '创建成功',
                type: 'success',
                duration: 2000
              });
            })
        } else {
          return false;
        }
      });
    },
    cancel(formName) {
      this.dialogFormVisible = false;
      const set = this.$refs;
      set[formName].resetFields();
    },
    update() {
      this.$refs.upload.submit();
      const token = util.cookies.get('token');
      var that = this;
      this.fileData.append("fileName", this.form.fileName);
      this.fileData.append("id", this.form.id);
      axios({
        url: process.env.VUE_APP_API + '/api/case/caseFileTemplate/update',
        method: 'post',
        data: that.fileData,
        dataType: 'json',
        responseType: 'blob',
        headers: {
          // 项目中请求头需要的信息（如果不需要可不写），如用户登录信息验证：
          authorization: 'Bearer ' + token
        }
      }).then((res) => {
        this.getList();
        this.dialogFormVisible = false;
        this.$notify({
          title: '成功',
          message: '创建成功',
          type: 'success',
          duration: 2000
        });
      }).catch((error) => {
      })
    },
    beforeUpload() {
      this.fileParams = { 'fileName': this.form.fileName };
    },
    fileChange(file, fileList) {
      this.fileData = new FormData();
      this.fileData.append("fields", file); // append增加数据
    },
    uploadAction() {
      return process.env.VUE_APP_API + "/api/case/caseFileTemplate/upload";
    },
    HttpUploadFile(file) {
      this.fileData = new FormData();
      this.fileData.append("fields", file.file); // append增加数据
      this.fileData.append("fileName", this.form.fileName);
    },

    submitUpload() {

      this.$refs.upload.submit();
      const token = util.cookies.get('token');
      var that = this;
      axios({
        url: process.env.VUE_APP_API + '/api/case/caseFileTemplate/upload',
        method: 'post',
        data: that.fileData,
        dataType: 'json',
        responseType: 'blob',
        headers: {
          // 项目中请求头需要的信息（如果不需要可不写），如用户登录信息验证：
          authorization: 'Bearer ' + token
        }
      }).then((res) => {
        this.getList();
        this.dialogFormVisible = false;
        this.$notify({
          title: '成功',
          message: '创建成功',
          type: 'success',
          duration: 2000
        });
      }).catch((error) => {

      })
    },

    download(id) {
      const token = util.cookies.get('token')
      axios({
        url: process.env.VUE_APP_API + '/api/case/caseFileTemplate/downloadTemplate/' + id,
        method: 'get',
        dataType: 'json',
        responseType: "arraybuffer",
        headers: {
          // 项目中请求头需要的信息（如果不需要可不写），如用户登录信息验证：
          authorization: 'Bearer ' + token
        }
      }).then(res => {
        const disposition = res.headers['content-disposition'];
        const fileName = decodeURI(disposition)
        let url = window.URL.createObjectURL(new Blob([res.data], { type: '.zip' }));
        let a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.setAttribute('download', fileName);
        document.body.appendChild(a);
        a.click();
        url = window.URL.revokeObjectURL(url);
        document.body.removeChild(a)
      }).catch(error => {
      })
    },
    resetTemp() {
      this.form = {
        fileName: undefined
      };
    },
    testReturn(val){
      console.log("回调时间")
      console.log(val)
      directUpload(val).then(res => {
        console.log(res)
      })
    }
  }
}
</script>
